// Author: Kevin Thomas : XKO
// Date: 02/11/04
// JOB 22124

// This file contains barcode check-digit javascript functions for WModulo47
import ccd_GetFullASCIIcode from "./BarcodeCCD_GetFullASCIIcode";
import ccd_GetFullASCIIchar from "./BarcodeCCD_GetFullASCIIchar";
function ccd_WModulo47(strCode) {
  var i, intTot, intWeight, chrCurr, intLen, chrCheckC, chrCheckK, strCheck;
  var intCharCode, intIdx;

  intTot = 0;

  intLen = strCode.length;

  for (i = 0; i < strCode.length; i++)
    if (strCode.charAt(i) == "(") intLen -= 2;

  intWeight = intLen % 20;

  if (intWeight == 0) intWeight = 20;

  intIdx = 0;

  for (i = 0; i < intLen; i++) {
    if (strCode.charAt(intIdx) == "(") {
      chrCurr = strCode.substr(intIdx, 3);
      intIdx += 3;
    } else {
      chrCurr = strCode.charAt(intIdx);
      intIdx++;
    }
    intTot += ccd_GetFullASCIIcode(chrCurr) * intWeight;

    if (intWeight == 1) intWeight = 20;
    else intWeight--;
  }

  intCharCode = intTot % 47;
  chrCheckC = ccd_GetFullASCIIchar(intCharCode);

  intTot = 0;
  intWeight = (intLen % 15) + 1;

  if (intWeight == 0) intWeight = 1;

  for (i = 0; i < intLen; i++) {
    if (strCode.charAt(i) == "(") chrCurr = strCode.substr(i, 3);
    else chrCurr = strCode.charAt(i);
    intTot += ccd_GetFullASCIIcode(chrCurr) * intWeight;

    if (intWeight == 1) intWeight = 15;
    else intWeight--;
  }

  intTot += ccd_GetFullASCIIcode(chrCheckC) * intWeight;

  intCharCode = intTot % 47;
  chrCheckK = ccd_GetFullASCIIchar(intCharCode);

  strCheck = chrCheckC + chrCheckK;

  return strCheck;
}
export default ccd_WModulo47;
